﻿/* LedovýLev — theme.js  (vanilla, no deps) */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || "{{amount}} Kč";
    var amount = Math.round(cents / 100).toLocaleString("cs-CZ");
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };
  var store = {
    get: function (k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var FREE_SHIP = parseInt(document.documentElement.getAttribute("data-free-ship") || "200000", 10);

  /* ---- Mobile nav ------------------------------------------------------ */
  function nav() {
    var menu = $("#mobile-nav"), scrim = $("#scrim"), open = $("#nav-open"), close = $("#nav-close");
    if (!menu) return;
    function set(on) {
      menu.toggleAttribute("data-open", on);
      scrim.toggleAttribute("data-open", on);
      document.body.style.overflow = on ? "hidden" : "";
      if (open) open.setAttribute("aria-expanded", on);
    }
    open && open.addEventListener("click", function () { set(true); });
    close && close.addEventListener("click", function () { set(false); });
    scrim && scrim.addEventListener("click", function () { set(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
  }

  /* ---- Accordions ------------------------------------------------------ */
  function accordions() {
    $$(".acc__q").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var open = btn.getAttribute("aria-expanded") === "true";
        var panel = document.getElementById(btn.getAttribute("aria-controls"));
        btn.setAttribute("aria-expanded", String(!open));
        if (panel) panel.style.maxHeight = open ? "0px" : panel.scrollHeight + "px";
      });
    });
  }

  /* ---- Quantity steppers ----------------------------------------------- */
  function qty() {
    $$("[data-qty]").forEach(function (w) {
      var input = $("input", w);
      $$("[data-qty-btn]", w).forEach(function (b) {
        b.addEventListener("click", function () {
          var step = b.getAttribute("data-qty-btn") === "up" ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---- Product gallery + zoom ----------------------------------------- */
  function gallery() {
    var g = $("[data-gallery]"); if (!g) return;
    var main = $("[data-gallery-main]", g);
    $$("[data-gallery-thumb]", g).forEach(function (t) {
      t.addEventListener("click", function () {
        $$("[data-gallery-thumb]", g).forEach(function (x) { x.removeAttribute("aria-current"); });
        t.setAttribute("aria-current", "true");
        var fig = t.getAttribute("data-media");
        $$("[data-media-item]", main).forEach(function (m) {
          m.toggleAttribute("hidden", m.getAttribute("data-media-item") !== fig);
        });
      });
    });
    // hover/touch zoom
    var zoom = $("[data-zoom]", main);
    if (zoom) {
      zoom.addEventListener("mousemove", function (e) {
        var r = zoom.getBoundingClientRect();
        zoom.style.setProperty("--zx", ((e.clientX - r.left) / r.width * 100) + "%");
        zoom.style.setProperty("--zy", ((e.clientY - r.top) / r.height * 100) + "%");
      });
      zoom.addEventListener("mouseenter", function () { zoom.classList.add("is-zoom"); });
      zoom.addEventListener("mouseleave", function () { zoom.classList.remove("is-zoom"); });
    }
  }

  /* ---- Variant selection (visual only; updates price + hidden id) ------ */
  function variants() {
    var form = $("[data-product-form]"); if (!form) return;
    var data = window.__PRODUCT__; if (!data) return;
    var selected = {};
    function resolve() {
      var match = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      }) || data.variants[0];
      var idInput = $("[name='id']", form);
      if (idInput) idInput.value = match.id;
      var pNow = $("[data-price-now]");
      if (pNow) pNow.textContent = money(match.price);
      var atc = $("[data-atc]");
      if (atc) {
        atc.disabled = !match.available;
        $("[data-atc-label]", atc).textContent = match.available
          ? atc.getAttribute("data-label-add") : atc.getAttribute("data-label-soldout");
      }
      var sticky = $("[data-sticky-price]"); if (sticky) sticky.textContent = money(match.price);
    }
    $$("[data-opt]", form).forEach(function (group) {
      var idx = parseInt(group.getAttribute("data-opt"), 10);
      selected[idx] = group.getAttribute("data-default");
      $$("input", group).forEach(function (input) {
        if (input.checked) selected[idx] = input.value;
        input.addEventListener("change", function () { selected[idx] = input.value; resolve(); });
      });
    });
    resolve();
  }

  /* ---- Sticky ATC bar -------------------------------------------------- */
  function stickyAtc() {
    var bar = $("[data-sticky-bar]"), anchor = $("[data-atc]");
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.toggleAttribute("data-show", show);
      document.body.classList.toggle("has-sticky-atc", show);
    }, { rootMargin: "-80px 0px 0px 0px" });
    io.observe(anchor);
    var sb = $("[data-sticky-add]", bar);
    if (sb) sb.addEventListener("click", function () { anchor.click(); });
  }

  /* ---- Countdown ("order within … and we ship today") ------------------ */
  function countdown() {
    $$("[data-countdown]").forEach(function (el) {
      var cutoff = parseInt(el.getAttribute("data-countdown"), 10); // hour, local
      function tick() {
        var now = new Date();
        var end = new Date(); end.setHours(cutoff, 0, 0, 0);
        if (now >= end) end.setDate(end.getDate() + 1);
        var d = Math.max(0, end - now);
        var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        var out = $("[data-countdown-clock]", el);
        if (out) out.textContent = [h, m, s].map(function (n) { return ("0" + n).slice(-2); }).join(":");
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---- Free-shipping progress bar -------------------------------------- */
  function shipBar() {
    $$("[data-ship-bar]").forEach(function (bar) {
      var total = parseInt(bar.getAttribute("data-total") || "0", 10);
      var remain = Math.max(0, FREE_SHIP - total);
      var fill = $("[data-ship-fill]", bar);
      var label = $("[data-ship-label]", bar);
      if (fill) fill.style.width = Math.min(100, total / FREE_SHIP * 100) + "%";
      if (label) {
        label.innerHTML = remain > 0
          ? bar.getAttribute("data-msg-remain").replace("{amount}", "<strong>" + money(remain) + "</strong>")
          : bar.getAttribute("data-msg-done");
      }
    });
  }

  /* ---- Popups: discount (8s) + exit-intent ----------------------------- */
  function popups() {
    var disc = $("#popup-discount"), exit = $("#popup-exit");
    function show(el) {
      if (!el) return;
      el.removeAttribute("hidden");
      requestAnimationFrame(function () { el.setAttribute("data-open", ""); });
      el.setAttribute("aria-hidden", "false");
    }
    function hide(el) {
      if (!el) return;
      el.removeAttribute("data-open");
      el.setAttribute("aria-hidden", "true");
      setTimeout(function () { el.setAttribute("hidden", ""); }, 300);
    }
    $$("[data-popup-close]").forEach(function (b) {
      b.addEventListener("click", function () { hide(b.closest("[data-popup]")); });
    });
    $$("[data-popup]").forEach(function (p) {
      p.addEventListener("click", function (e) { if (e.target === p) hide(p); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") $$("[data-popup][data-open]").forEach(hide);
    });

    if (disc && !store.get("bd_disc_seen", false)) {
      setTimeout(function () {
        if (!$("[data-popup][data-open]")) { show(disc); store.set("bd_disc_seen", true); }
      }, 8000);
    }
    if (exit && !store.get("bd_exit_seen", false)) {
      var armed = false;
      setTimeout(function () { armed = true; }, 4000);
      document.addEventListener("mouseout", function (e) {
        if (!armed || e.relatedTarget || e.clientY > 12) return;
        if ($("[data-popup][data-open]")) return;
        show(exit); store.set("bd_exit_seen", true);
      });
    }
    // newsletter/popup form -> reveal code
    $$("[data-discount-form]").forEach(function (f) {
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var ok = f.querySelector("[data-discount-success]");
        var fields = f.querySelector("[data-discount-fields]");
        if (fields) fields.hidden = true;
        if (ok) ok.hidden = false;
      });
    });
  }

  /* ---- Recently viewed ------------------------------------------------- */
  function recentlyViewed() {
    var cur = window.__PRODUCT__;
    var KEY = "bd_recent";
    var list = store.get(KEY, []);
    if (cur && cur.handle) {
      list = list.filter(function (h) { return h !== cur.handle; });
      list.unshift(cur.handle);
      store.set(KEY, list.slice(0, 8));
    }
    var mount = $("[data-recently-viewed]");
    if (!mount) return;
    var handles = store.get(KEY, []).filter(function (h) { return !cur || h !== cur.handle; }).slice(0, 4);
    if (!handles.length) { mount.closest("[data-recent-section]") && mount.closest("[data-recent-section]").remove(); return; }
    Promise.all(handles.map(function (h) {
      return fetch(window.Shopify.routes.root + "products/" + h + ".js")
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      prods = prods.filter(Boolean);
      if (!prods.length) { var s = mount.closest("[data-recent-section]"); if (s) s.remove(); return; }
      mount.innerHTML = prods.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]);
        return '<a class="card" href="' + window.Shopify.routes.root + 'products/' + p.handle + '">' +
          '<div class="card__media">' + (img ? '<img loading="lazy" src="' + img + '" alt="' + (p.title || "") + '">' : "") + '</div>' +
          '<div class="card__body"><div class="card__title">' + p.title + '</div>' +
          '<div class="card__foot"><span class="price">' + money(p.price) + '</span></div></div></a>';
      }).join("");
    });
  }

  /* ---- Add to cart (AJAX) + drawer count ------------------------------- */
  function cart() {
    $$("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (!window.Shopify || !window.Shopify.routes) return; // let it post normally if no context
        e.preventDefault();
        var btn = $("[data-atc]", form);
        var label = btn && $("[data-atc-label]", btn);
        var prev = label && label.textContent;
        if (btn) { btn.disabled = true; if (label) label.textContent = btn.getAttribute("data-label-loading") || "…"; }
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: +form.querySelector("[name='id']").value, quantity: +(form.querySelector("[name='quantity']") || {}).value || 1 }] })
        }).then(function (r) { return r.json(); }).then(function () {
          return fetch(window.Shopify.routes.root + "cart.js").then(function (r) { return r.json(); });
        }).then(function (c) {
          var badge = $("[data-cart-count]");
          if (badge) { badge.textContent = c.item_count; badge.hidden = c.item_count === 0; }
          if (label) label.textContent = btn.getAttribute("data-label-added") || "Přidáno ✓";
          setTimeout(function () { if (btn) { btn.disabled = false; if (label) label.textContent = prev; } }, 1800);
          window.location.href = window.Shopify.routes.root + "cart";
        }).catch(function () { if (btn) { btn.disabled = false; if (label) label.textContent = prev; } });
      });
    });
  }

  /* ---- Cart page: auto-update on quantity change ----------------------- */
  function cartPage() {
    var form = $("[data-cart-form]"); if (!form) return;
    $$("[data-cart-qty]", form).forEach(function (inp) {
      inp.addEventListener("change", function () {
        if ((parseInt(inp.value, 10) || 0) < 0) inp.value = 0;
        form.submit();
      });
    });
  }

  /* ---- Motion vrstva --------------------------------------------------- */
  var REDUCED = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  /* Scroll-reveal se staggerem (auto-tag, žádné zásahy do liquid) */
  function reveal() {
    var SEL = ".section-head, .card, .split__card, .trust, .quote, .about-teaser__media, .lp-benefit, .team__card, .post-card, .hero__copy, .hero__media, .news-band, .social-proof__score, .reviews__summary, .pdp__block, .about-value, .contact__form-wrap";
    var nodes = $$(SEL);
    if (!nodes.length) return;
    if (REDUCED || !("IntersectionObserver" in window)) {
      nodes.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var seen = [];
    nodes.forEach(function (el) {
      el.setAttribute("data-reveal", "");
      var p = el.parentNode, rec = null;
      for (var i = 0; i < seen.length; i++) { if (seen[i].p === p) { rec = seen[i]; break; } }
      if (!rec) { rec = { p: p, n: 0 }; seen.push(rec); }
      el.style.setProperty("--reveal-delay", Math.min(rec.n, 6) * 80 + "ms");
      rec.n++;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    nodes.forEach(function (el) { io.observe(el); });
  }

  /* Header scroll-shrink / glass */
  function headerScroll() {
    var h = $(".site-header"); if (!h) return;
    var ticking = false;
    function upd() { h.classList.toggle("is-scrolled", window.scrollY > 10); ticking = false; }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* Hero parallax (média + copy; číslice float řeší CSS) */
  function heroParallax() {
    if (REDUCED) return;
    var hero = $(".hero"); if (!hero) return;
    var media = $(".hero__media", hero), copy = $(".hero__copy", hero);
    var ticking = false;
    function upd() {
      var y = window.scrollY;
      if (media) media.style.transform = "translateY(" + (y * -0.05) + "px)";
      if (copy) copy.style.transform = "translateY(" + (y * 0.03) + "px)";
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (window.scrollY > window.innerHeight) return;
      if (!ticking) { ticking = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* Dopočítávané statistiky (reveal-triggered) */
  function counters() {
    var els = $$(".social-proof__num, .reviews__big, .lp-proof__num");
    if (!els.length || REDUCED || !("IntersectionObserver" in window)) return;
    function run(el) {
      var raw = el.textContent.trim();
      var m = raw.match(/([0-9]+(?:[.,][0-9]+)?)/);
      if (!m) return;
      var num = m[1], target = parseFloat(num.replace(",", "."));
      var decimals = (num.split(/[.,]/)[1] || "").length;
      var prefix = raw.slice(0, m.index), suffix = raw.slice(m.index + num.length);
      var dur = 1100, start = null;
      function frame(t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        var cur = target * eased;
        var shown = decimals ? cur.toFixed(decimals).replace(".", ",") : Math.round(cur).toLocaleString("cs-CZ");
        el.textContent = prefix + shown + suffix;
        if (p < 1) requestAnimationFrame(frame); else el.textContent = raw;
      }
      requestAnimationFrame(frame);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Buy now — přidej do košíku a rovnou na checkout */
  function buyNow() {
    $$("[data-buynow]").forEach(function (b) {
      b.addEventListener("click", function () {
        var form = b.closest("[data-product-form]"); if (!form) return;
        if (!window.Shopify || !window.Shopify.routes) { form.submit(); return; }
        var idEl = form.querySelector("[name='id']"); if (!idEl) return;
        var qty = +(form.querySelector("[name='quantity']") || {}).value || 1;
        var prev = b.innerHTML;
        b.disabled = true; b.textContent = "Přesměrovávám…";
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: +idEl.value, quantity: qty }] })
        }).then(function (r) {
          if (!r.ok) throw new Error("add failed");
          window.location.href = window.Shopify.routes.root + "checkout";
        }).catch(function () { b.disabled = false; b.innerHTML = prev; });
      });
    });
  }

  /* Plovoucí podpora / chat */
  function support() {
    var root = $("[data-support]"); if (!root) return;
    var fab = $("[data-support-fab]", root);
    function set(open) {
      root.toggleAttribute("data-open", open);
      if (fab) fab.setAttribute("aria-expanded", String(open));
    }
    $$("[data-support-toggle]", root).forEach(function (b) {
      b.addEventListener("click", function (e) { e.stopPropagation(); set(!root.hasAttribute("data-open")); });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
    document.addEventListener("click", function (e) { if (!root.contains(e.target)) set(false); });
  }

  /* Hero „type-out" nadpis */
  function heroType() {
    var el = $("[data-typetarget]"); if (!el) return;
    var full = (el.textContent || "").trim();
    if (!full || REDUCED) return;
    el.style.minHeight = el.offsetHeight + "px";   // rezervuj výšku proti reflow
    el.classList.add("is-typing");
    el.textContent = "";
    var caret = document.createElement("span");
    caret.className = "type-caret"; caret.setAttribute("aria-hidden", "true");
    el.appendChild(caret);
    var i = 0;
    function step() {
      if (i < full.length) {
        caret.insertAdjacentText("beforebegin", full.charAt(i));
        i++;
        setTimeout(step, full.charAt(i - 1) === " " ? 95 : 58);
      }
    }
    setTimeout(step, 360);
  }

  /* Cookie lišta (GDPR) — volba v localStorage */
  function cookies() {
    var bar = $("[data-cookie]"); if (!bar) return;
    var KEY = "ll_cookie";
    if (store.get(KEY, null)) return; // už rozhodnuto → zůstane skryté
    bar.hidden = false;
    document.body.classList.add("has-cookie");
    requestAnimationFrame(function () { bar.classList.add("is-open"); });
    function decide(v) {
      store.set(KEY, v);
      bar.classList.remove("is-open");
      document.body.classList.remove("has-cookie");
      setTimeout(function () { bar.hidden = true; }, 320);
    }
    var a = $("[data-cookie-accept]", bar), e = $("[data-cookie-essential]", bar);
    if (a) a.addEventListener("click", function () { decide("all"); });
    if (e) e.addEventListener("click", function () { decide("essential"); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    nav(); accordions(); qty(); gallery(); variants(); stickyAtc();
    countdown(); shipBar(); popups(); recentlyViewed(); cart(); cartPage();
    reveal(); headerScroll(); heroParallax(); counters();
    buyNow(); support(); heroType(); cookies();
  });
})();
